import Vue from "vue";
import Vuex from "vuex";

import notification from "./modules/notification";
import session from "./modules/session";
import request from "./modules/request";
import users from "./modules/users";

Vue.use(Vuex);

const store = new Vuex.Store({
	modules: {
		notification,
		session,
		request,
		users
	}
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js